import React, { useContext } from 'react';
import { strapiUrl } from '../../../../utils/constants';
import DownloadFile from '../Elements/DownloadFile';
import { Context } from '../Wizard/WizardWrapper';

const buttonLabels = {
  curriculumVitae: 'Curriculum Vitae',
  extendedCitation: 'Extended Citation',
  significantPublications: 'Significant Publications',
  publications: 'Publications',
};

const RefereeTitle = () => {
  const { refereeReportData } = useContext(Context);

  if (!refereeReportData) {
    return null;
  }

  return (
    <div className="col-lg-12">
      <div className="form-group" />
      <h1 className="mb-xl-3">
        {refereeReportData.candidate}{' '}
        <span className="badge badge-info badge-small">
          {refereeReportData.electionType}
        </span>
      </h1>

      <h3 className="mt-xl-4">Short citation</h3>
      <p>
        {refereeReportData.nominationState?.[0]?.attributes?.citation || ''}
      </p>

      <h3 className="mt-xl-5 mb-xl-3">Download documentation</h3>
      <div className="documentation mb-xl-5">
        {Object.keys(buttonLabels).map(
          (label) =>
            refereeReportData.nominationState?.[0]?.attributes?.[label]
              ?.data && (
              <DownloadFile
                key={label}
                text={buttonLabels[label]}
                url={`${strapiUrl}${refereeReportData.nominationState[0].attributes[label].data.attributes.url}`}
                name={label}
                buttonClassName="btn btn-outline-primary sw-btn-next ms-1 mt-1 me-4"
                showFileName={false}
              />
            ),
        )}
      </div>
    </div>
  );
};

export default RefereeTitle;
